import { useParams } from 'react-router-dom';
import { useGetSectionSubjectUnitLesson } from 'chalktalk-react/hooks/useGetSectionSubjectUnitLesson';
import { CurriculumSubjectRecord } from '../types';

const useSubjects = (subjectId?: number): CurriculumSubjectRecord[] => {
  const { subjectId: curriculumSubjectId } = useParams();
  const { curriculumSubjects } = useGetSectionSubjectUnitLesson();

  if (!curriculumSubjects) {
    return [];
  }

  const currentCurriculumSubject = curriculumSubjects.find((cs) =>
    curriculumSubjectId
      ? cs.id.toString() === curriculumSubjectId.toString()
      : cs.subject.id === subjectId,
  );

  if (!currentCurriculumSubject) {
    return [];
  }

  return curriculumSubjects.filter(
    (cs) => cs.subject.id === currentCurriculumSubject.subject.id,
  );
};

export default useSubjects;
